module.exports = __webpack_public_path__ + "assets/img/bfd6-nu.svg";